import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

interface CardProps {
  title?: string;
  value?: string;
  subtitle?: string;
  icon?: IconName;
  children?: ReactNode;
  variant?: 'default' | 'highlight' | 'warning' | 'danger' | 'success';
  onClick?: () => void;
}

export function Card({
  title,
  value,
  subtitle,
  icon,
  children,
  variant = 'default',
  onClick,
}: CardProps) {
  const tone = variant === 'success' ? 'highlight' : variant;
  const className = ['metric-card', tone, onClick ? 'clickable' : ''].filter(Boolean).join(' ');
  const content = children ?? (
    <>
      <span className="metric-label">
        {title}
        {icon && <Icon name={icon} />}
      </span>
      <span className="metric-value">{value}</span>
      {subtitle && <span className="metric-detail">{subtitle}</span>}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={className} onClick={onClick}>
        {content}
      </button>
    );
  }
  return <div className={className}>{content}</div>;
}
